<dashboard-dialog-frame icon='fa-regular fa-award' [header]="dialogContext.data?.awardId ? 'Edit Award' : 'Add Award'" [dialogRef]='dialogRef'>

	<div class="d-flex flex-column justify-content-between h-100 p-3">
		<div class="d-flex flex-column gap-2">
			<common-select-field [field]="awardEditorForm.venture()"></common-select-field>
			<common-select-field [field]="awardEditorForm.awardName()"></common-select-field>
			<common-select-field [field]="awardEditorForm.decidingRole()"></common-select-field>
			<common-select-field [field]="awardEditorForm.awardKind()"></common-select-field>
			<common-number-field [field]="awardEditorForm.value()"></common-number-field>
			<common-text-field [field]="awardEditorForm.notes()"></common-text-field>

		</div>

		<common-button-row [center]="true">
			<button #formSaveBtn class="btn btn-primary">{{dialogContext.data?.awardId ? 'Edit' : 'Add'}}</button>
			<button class="btn btn-standard" (click)="resetForm()">Revert</button>
			<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
		</common-button-row>
	</div>

</dashboard-dialog-frame>